export default __webpack_public_path__ + "locales/pt/EmptyTrashDialog.json?hash=aca63611b58f3739b8982fab260e148f";